import { useMemo } from 'react';
import type { VoidFunctionComponent } from 'react';

import usePackageLocators from '../../../hooks/api/packages/usePackageLocators';
import useDebouncedInputValue from '../../../hooks/useDebouncedInputValue';
import { selectOptionFactory } from '../../../utils';
import Select from '../../generic/Select/Select';
import type { AnyFilter } from '../../../../shared/organizationPackages/filters';
import type { SelectOption } from '../../../types';

const debounceTimeMs = 250;

type Props = {
  locators: SelectOption[];
  setFilters: (...args: AnyFilter[]) => void;
};

/**
 * Renders an autocomplete package locators dropdown
 */
const PackageLocatorFilter: VoidFunctionComponent<Props> = ({ locators, setFilters }) => {
  const { onChange: updateSearchValue, debouncedValue: debouncedSearchValue } = useDebouncedInputValue(
    '', // defaulting to an empty string for the initial search value to start with an empty filter
    debounceTimeMs,
  );

  const { data } = usePackageLocators(debouncedSearchValue || undefined);
  const options = useMemo(() => data?.results.map(locator => selectOptionFactory(locator)) ?? [], [data]);

  return (
    <Select
      id="package-index-locator-filter"
      isMulti
      onInputChange={(searchValue => updateSearchValue(searchValue))}
      options={options}
      placeholder="Locators"
      value={locators}
      onChange={(selectedOptions: SelectOption[]) => {
        setFilters({
          locators: selectedOptions.map((option) => option.value),
        });
      }}
    />
  );
};

export default PackageLocatorFilter;
